/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PromptFilters extends models.PromptFiltersRequest {
    getFixupPrototypeFunction() { return PromptFilters.fixupPrototype; }

    static newInstance(model: Partial<PromptFilters>): PromptFilters {
        let obj = Object.assign(new PromptFilters(), model);
        PromptFilters.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PromptFilters>): PromptFilters {
        if (!model) return null;
        return PromptFilters.newInstance(<PromptFilters> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PromptFilters) {
        if (!obj) return;

        models.PromptFilters.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PromptFilters): boolean {
        if (models.PromptFiltersRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PromptFilters.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.tags) {
            for (let val of this.tags) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
    }

    /**
     * Name of the prompt
     */
    prompt: string;

    /**
     * List of tag key/value pairs
     */
    tags: Array<models.KeyValuePair>;

}
